import OfficeTileContent from "@/app/features/organisation/OfficeTileContent"
import { Office } from "@/app/features/organisation/types"
import { Button } from "@/components/ui/button"
import { Command, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList } from "@/components/ui/command"
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover"
import { CommandLoading } from "cmdk"
import { MoreVertical } from "lucide-react"
import { useCallback, useEffect, useRef, useState } from "react"

type OfficeSelectorProps = {
    office: number;
    editable?: boolean;
    onSelect?: (office: Office) => void;
    offices: Office[];
    isLoading: boolean;
}

const OfficeSelector = ({ office, editable = true, onSelect, offices, isLoading = false }: OfficeSelectorProps) => {

    const [selectOfficeOpen, setSelectOfficeOpen] = useState(false)
    const [selectedOffice, setSelectedOffice] = useState<Office | undefined>(undefined);
    const containerRef = useRef<HTMLDivElement | null>(null);
    const [containerWidth, setContainerWidth] = useState<number | undefined>(undefined);

    useEffect(() => {
        console.info('OfficeSelector useEffect', { office, offices });
        setSelectedOffice(offices?.find((o) => o.id === office));
    }, [office, offices]);

    const handleSelect = useCallback((office: Office) => {
        console.info('handleSelect', office);
        setSelectedOffice(office);
        onSelect?.(office);
        setSelectOfficeOpen(false);
    }, [onSelect]);

    const handleOpen = useCallback(() => {
        setSelectOfficeOpen(true);
    }, []);

    useEffect(() => {
        const updateWidth = () => {
            if (containerRef.current) setContainerWidth(containerRef.current.getBoundingClientRect().width);
        };
        updateWidth();
        window.addEventListener('resize', updateWidth);
        return () => window.removeEventListener('resize', updateWidth);
    }, [selectedOffice, offices]);

    return (
        <div ref={containerRef} className="flex items-center justify-between p-4 bg-gray-100 rounded-lg">
            <OfficeTileContent office={selectedOffice} numberOfOffices={offices?.length ?? 0} />

            {editable && (
                <>
                    <Popover open={selectOfficeOpen} onOpenChange={setSelectOfficeOpen}>
                        <PopoverTrigger asChild>
                            <Button variant="ghost" size="icon" onClick={handleOpen} aria-label="Change office">
                                <MoreVertical className="h-4 w-4" />
                            </Button>
                        </PopoverTrigger>
                        <PopoverContent className="p-0" align="end" style={{ width: containerWidth ? `${containerWidth}px` : undefined }}>
                            <Command>
                                <CommandInput placeholder="Search Offices..." />
                                <CommandList>
                                    {isLoading ? (
                                        <CommandLoading>Loading offices...</CommandLoading>
                                    ) : (
                                        <>
                                            <CommandEmpty>No results found.</CommandEmpty>
                                            <CommandGroup heading="Offices">
                                                {offices?.map((office) => (
                                                    <CommandItem key={office.id} onSelect={() => handleSelect(office)} className="space-y-2">
                                                        <OfficeTileContent office={office} />
                                                    </CommandItem>
                                                ))}
                                            </CommandGroup>
                                        </>
                                    )}
                                </CommandList>
                            </Command>
                        </PopoverContent>
                    </Popover>
                </>
            )}

        </div>


    )
}


export default OfficeSelector;